import VideoCard from '@/components/feature/VideoCard';

const latestVideoList = [
  {
    id: 'v007',
    title: '赛博朋克2077：边缘行者完整版',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '1:45:30',
    views: '580万',
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20cinematic%20scene%20with%20neon%20city%20nightscape%2C%20dramatic%20contrast%20lighting%2C%20futuristic%20composition%2C%20vibrant%20neon%20and%20dark%20tones%2C%20professional%20animation%20art%2C%20clean%20dark%20gradient%20background&width=640&height=360&seq=lat-v007&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v008',
    title: '荒野猎人：绝境求生之路',
    category: '动作大片',
    categorySlug: 'dongzuo',
    duration: '2:36:15',
    views: '430万',
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Wilderness%20survival%20cinematic%20scene%20with%20snowy%20mountain%20landscape%2C%20cold%20natural%20lighting%2C%20epic%20wide%20composition%2C%20cool%20white%20and%20warm%20contrast%20tones%2C%20professional%20film%20photography%2C%20clean%20atmospheric%20background&width=640&height=360&seq=lat-v008&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v009',
    title: '你好李焕英：温情母爱催泪巨制',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '2:08:00',
    views: '1120万',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20cinematic%20scene%20with%20nostalgic%201980s%20Chinese%20setting%2C%20soft%20warm%20golden%20lighting%2C%20intimate%20composition%2C%20gentle%20vintage%20tones%2C%20professional%20film%20photography%2C%20clean%20warm%20background&width=640&height=360&seq=lat-v009&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v010',
    title: '黑客帝国：矩阵重启',
    category: '科幻奇幻',
    categorySlug: 'kehuan',
    duration: '2:28:44',
    views: '890万',
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20matrix%20cinematic%20scene%20with%20green%20code%20rain%20effect%2C%20dramatic%20cyber%20lighting%2C%20dynamic%20composition%2C%20dark%20tech%20tones%2C%20professional%20film%20photography%2C%20clean%20dark%20background&width=640&height=360&seq=lat-v010&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v011',
    title: '地球脉动第三季：生命奇迹',
    category: '纪录纪实',
    categorySlug: 'jilu',
    duration: '1:00:00',
    views: '350万',
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20wildlife%20documentary%20cinematic%20scene%20with%20diverse%20animal%20species%2C%20golden%20natural%20sunlight%2C%20epic%20landscape%20composition%2C%20rich%20vibrant%20natural%20tones%2C%20professional%20nature%20photography%2C%20clean%20atmospheric%20background&width=640&height=360&seq=lat-v011&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v012',
    title: '夏洛特烦恼：爆笑穿越喜剧',
    category: '喜剧搞笑',
    categorySlug: 'xiju',
    duration: '1:44:20',
    views: '760万',
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20cinematic%20scene%20with%20nostalgic%20school%20setting%2C%20bright%20cheerful%20lighting%2C%20funny%20dynamic%20composition%2C%20warm%20playful%20tones%2C%20professional%20film%20photography%2C%20clean%20light%20background&width=640&height=360&seq=lat-v012&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v013',
    title: '进击的巨人最终季完结篇',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '1:30:00',
    views: '920万',
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20cinematic%20scene%20with%20massive%20titans%20and%20dramatic%20sky%2C%20intense%20warm%20lighting%2C%20dynamic%20composition%2C%20powerful%20dramatic%20tones%2C%20professional%20animation%20art%2C%20clean%20epic%20background&width=640&height=360&seq=lat-v013&orientation=landscape',
    isNew: true,
  },
  {
    id: 'v014',
    title: '我不是药神：现实主义力作',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '1:57:00',
    views: '1350万',
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Realistic%20Chinese%20drama%20cinematic%20scene%20with%20urban%20street%20setting%2C%20natural%20muted%20lighting%2C%20intimate%20street%20composition%2C%20warm%20earthy%20tones%2C%20professional%20film%20photography%2C%20clean%20urban%20background&width=640&height=360&seq=lat-v014&orientation=landscape',
  },
];

export default function LatestVideosSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
              <i className="ri-time-line text-primary-500 mr-2"></i>
              最新上线
            </h2>
            <p className="text-foreground-500 text-sm">每日更新，精彩不重样</p>
          </div>
          <a
            href="/category/dongman"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestVideoList.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <a
            href="/category/dongman"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            查看全部最新视频
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}